<template>
    <div>
        <h1 class="is-size-2">Utilerias</h1>
        <h3 class="is-size-3">Respuestas del API</h3>
        <p>Todas las respuestas de las rutas son en formato JSON</p>
        <hr />
        <h3 class="is-size-3">Placeholders</h3>
        <p>
            Algunas rutas necesitan de uno o más parametros para dar respuesta,
            los parametros estan presentados en las url entre llaves
            <code>{ }</code> indicando el parametro que se necesita.
        </p>
        <br />
        <p>
            Por ejemplo en:
            <code>{{ host }}/api/countryData/{countryCode}</code>
            <br />
            La petición sería:
            <code
                >{{ host }}/api/countryData/<strong
                    >MEX</strong
                ></code
            >
        </p>
        <br />
        <p>
            Existen parametros <strong>opcionales</strong> y estos se
            representan con un signo de interrogación <code>?</code>
        </p>
        <br />
        <p>
            Por ejemplo en:
            <code>{{ host }}/api/locations/{stateCode?}</code> <br />
            La petición puede ser:
            <code>{{ host }}/api/locations</code> ó
            <code>{{ host }}/api/locations/08</code>
        </p>
    </div>
</template>

<script>
export default {
    data () {
        return {
            host: process.env.VUE_APP_HOST
        }
    }
}
</script>

<style scoped>
</style>
